export function isExpressionSpecification(descriptor: any)
{
    return descriptor.expression != null;
}
